import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import type { CuentaTotal } from '../../lib/api.js';
import { AXIS, GRID, OTRAS_COLOR, TOOLTIP_STYLE } from './ChartCard.js';

/**
 * Ranking de cuentas por noches del período (barras horizontales).
 *
 * Una sola serie: sin leyenda — el título ya la nombra — y con el valor como
 * etiqueta directa al final de cada barra, que con pocas cuentas se lee mejor
 * que obligar al ojo a ir al eje. El color de cada barra es el MISMO que en la
 * serie mensual, así que la identidad no depende de recordar el orden.
 */
export function CuentasRankingChart({
  data,
  colores,
}: {
  data: CuentaTotal[];
  colores: Map<string, string>;
}) {
  const rows = data.map((c) => ({ cuenta: c.cuenta, noches: c.noches }));
  const alto = Math.max(200, rows.length * 38 + 40);
  return (
    <ResponsiveContainer width="100%" height={alto}>
      <BarChart data={rows} layout="vertical" margin={{ top: 8, right: 48, bottom: 8, left: 8 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={GRID} horizontal={false} />
        <XAxis type="number" tick={AXIS} allowDecimals={false} />
        <YAxis type="category" dataKey="cuenta" tick={AXIS} width={124} />
        <Tooltip
          contentStyle={TOOLTIP_STYLE}
          formatter={(v: number) => [v.toLocaleString('es-VE'), 'Noches']}
        />
        <Bar dataKey="noches" name="Noches" radius={[0, 4, 4, 0]} barSize={22}>
          {rows.map((r) => (
            <Cell key={r.cuenta} fill={colores.get(r.cuenta) ?? OTRAS_COLOR} />
          ))}
          <LabelList
            dataKey="noches"
            position="right"
            // El valor va en tinta de texto, no en el color de la serie: el
            // color ya lo lleva la barra que tiene al lado.
            fill="#cbd5e1"
            fontSize={11}
            formatter={(v: number) => v.toLocaleString('es-VE')}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
